import { render } from "./PanelAvisosFormPago.vue?vue&type=template&id=724c459c"
import script from "./PanelAvisosFormPago.vue?vue&type=script&lang=js"
export * from "./PanelAvisosFormPago.vue?vue&type=script&lang=js"
script.render = render

export default script